import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";



const JobOrderList = () => {
  const [jobList, setJobList] = useState([]);
  const [change, setChange] = useState(false);

  useEffect(() => {
    api
      .get("/services/joborders/details/")
      .then((response) => {
        // console.log(response.data)
        setJobList(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [change]);

  const handlePatch = (e, name, id) => {
    // console.log('e',e)
    // console.log('name', name)
    // let status = {
    //   status: name,
    // };

    if(name === "complete"){
      api
      .patch(`/services/joborders/details/${id}/complete/`)
      .then((response) => {
        setChange(!change);
        toast.success("Status Change");
      })
      .catch((error) => {
        toast.error("Unable To Change");
      });

    }else {
      api
      .patch(`/services/joborders/details/${id}/approve/`)
      .then((response) => {
        setChange(!change);
        toast.success("Status Change");
      })
      .catch((error) => {
        toast.error("Unable To Change");
      });
    }

   
  };

  return (
    <div className="">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Job Order List With Status
      </h1>
      <div className="">
        <img
          src="../../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>
      {/*  table */}
      <div className="mt-3 w-full md:px-10">
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-4 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <table className="border-primary-blue min-w-full border-2 text-center">
                  <thead className="bg-primary-red border-primary-blue border-2">
                    <tr>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        SN.
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        J.No
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Date
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Company Name
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Job Details
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Client/User Name
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Total Amount
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody className="font-Acme">
                    {jobList.map((item, i) => {
                      return (
                        <tr className="border-b bg-white">
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {i + 1}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.id}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.created_on}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.company_name}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
                            {item.details}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            {item?.contact_person_name}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap rounded-full border-2 py-2 px-4 text-sm">
                            {item.amount}
                          </td>
                          <td className="border-primary-blue whitespace-nowrap border-2 py-2 px-4 text-xs text-white">
                            <p className="text-black text-base">
                              {item.status}
                            </p>
                          </td>
                          <td className="border-primary-blue w-[400px] whitespace-nowrap border-2 py-2 px-4 text-xs">
                            {/* {item.status === "approved" ? (
                              <>
                              
                                <button
                                  className="bg-primary-green rounded-3xl p-2"
                                  onClick={(e) =>
                                    handlePatch(e, "complete", item.id)
                                  }>
                                  Complete
                                </button>
                              </>
                            ): 
                            <>
                              <button
                                  className="bg-primary-green rounded-3xl p-2"
                                  onClick={(e) =>
                                    handlePatch(e, "complete", item.id)
                                  }>
                                  Complete
                                </button>
                            
                            </> */}
                            {
                              item.status === "approved" ? 
                               <button className="bg-primary-green rounded-3xl p-2"
                                onClick={(e)=> handlePatch(e, "complete", item.id)}
                               >
                                Complete
                               </button>:
                               <button
                               className="bg-primary-green rounded-3xl p-2"
                               onClick={(e)=> handlePatch(e, "approve", item.id)}
                               >
                                 Approved
                               </button>
                            }




                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
                <div className="mt-5 flex items-center justify-end gap-10">
                  <div className="bg-primary-green font-Berkshire rounded-md px-5 py-3 font-bold text-white">
                    <a href="">Print List</a>
                  </div>
                  <div className="bg-primary-blue rounded-md px-5 py-3 font-bold text-white">
                    <a href="">View More</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobOrderList;
